import { Sparkle } from "./Sparkle";

const ITEMS = [
  "Agendas",
  "Pulseiras",
  "Colares",
  "Brincos",
  "Pingentes de Celular",
  "Canecas Personalizadas",
  "Marca Páginas",
  "Quadros Decorativos",
];

const Row = ({ ariaHidden }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {ITEMS.map((it, i) => (
      <span key={i} className="flex items-center whitespace-nowrap font-display text-xl font-semibold uppercase tracking-wider sm:text-2xl">
        <span className={i % 2 ? "text-transparent [-webkit-text-stroke:1.5px_rgba(255,255,255,0.92)]" : "text-white"}>{it}</span>
        <Sparkle className="mx-7 h-5 w-5 shrink-0 text-white" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div className="relative z-10 overflow-hidden py-8" data-testid="brand-marquee">
      <div className="-mx-3 -rotate-1 border-y-[3px] border-ink/10 bg-gradient-to-r from-pinky via-lilac to-babyblue py-4 shadow-[0_14px_40px_rgba(183,148,230,0.3)]">
        <div className="marquee-track flex w-max">
          <Row ariaHidden={false} />
          <Row ariaHidden={true} />
        </div>
      </div>
    </div>
  );
}
